import { ApiSubUrls, Apis } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'
import { IAppContext, IPreferences, IAppContextItem } from 'types/user-context'

interface IUpdateUserContextProps {
    app_id: string
    user_id: string
    app_context: IAppContextItem[]
}

const url = `${ApiSubUrls[Apis.AGGREGATIONS]}/user_contexts/`

export const fetchUserContext = fetchGeneralData<IPreferences>(url)

export const updateUserContext = fetchGeneralData<
    IAppContext,
    IUpdateUserContextProps
>(url)
